module.exports = __webpack_public_path__ + "pc/img/rec_09.31b5e798.svg";